import { RegionInfo } from '../../pages/PluvaAutoLandingPage/components/NationwideDealershipStatusSection';

export const gyeonggiChungcheongRegions: RegionInfo[] = [
  {
    region: '경기',
    cityDealerList: [
      {
        name: '평택, 화성, 안성, 이천, 여주',
        tel: '010-4922-9987',
      },
    ],
  },
  {
    region: '강화',
    cityDealerList: [
      {
        name: '강화, 김포, 고양, 파주',
        tel: '010-6347-2018',
      },
    ],
  },
  {
    region: '충북',
    cityDealerList: [
      {
        name: '충북 전지역',
        tel: '010-4707-9476',
      },
    ],
  },
  {
    region: '충남',
    cityDealerList: [
      {
        name: '태안, 서산, 당진, 아산, 천안, 홍성, 예산',
        tel: '010-5113-0921',
      },
      {
        name: '부여, 청양',
        tel: '010-7939-1089',
      },
      {
        name: '논산',
        tel: '010-5425-0738',
      },
      {
        name: '서천, 보령',
        tel: '010-9290-0038',
      },
    ],
  },
];

export const jeollaRegions: RegionInfo[] = [
  {
    region: '전북',
    cityDealerList: [
      {
        name: '군산, 김제, 익산, 완주',
        tel: '010-2652-7814',
      },
      {
        name: '김제',
        tel: '010-3683-6114',
      },
      {
        name: '익산',
        tel: '010-8641-1571',
      },
      {
        name: '완주',
        tel: '010-5262-2929',
      },
      {
        name: '진안',
        tel: '010-8668-7075',
      },
      {
        name: '장수',
        tel: '010-3673-8436',
      },
      {
        name: '임실',
        tel: '010-3656-5407',
      },
      {
        name: '남원',
        tel: '010-9946-7751',
      },
      {
        name: '순창',
        tel: '010-8535-2041',
      },
      {
        name: '정읍',
        tel: '010-5653-2487',
      },
      {
        name: '고창',
        tel: '010-4656-0896',
      },
      {
        name: '부안',
        tel: '010-6672-3900',
      },
    ],
  },
  {
    region: '전남',
    cityDealerList: [
      {
        name: '함평',
        tel: '010-4921-5386',
      },
      {
        name: '무안',
        tel: '010-8620-7484',
      },
      {
        name: '나주, 영광, 신안',
        tel: '010-3614-0049',
      },
      {
        name: '해남',
        tel: '010-4643-4885',
      },
      {
        name: '보성, 화순, 담양, 여수, 광양, 순천, 곡성, 구례, 고흥',
        tel: '010-3642-3630',
      },
      {
        name: '진도',
        tel: '010-3889-3376',
      },
      {
        name: '장성',
        tel: '010-8621-9772',
      },
    ],
  },
];

export const gyeongsangRegions: RegionInfo[] = [
  {
    region: '경북',
    cityDealerList: [
      {
        name: '상주',
        tel: '010-6414-4635',
      },
      {
        name: '성주, 칠곡, 고령, 대구 달성',
        tel: '010-3539-0291',
      },
      {
        name: '예천, 문경, 영주',
        tel: '010-9209-4254',
      },
      {
        name: '의성',
        tel: '010-5005-3438',
      },
      {
        name: '경주, 포항',
        tel: '010-3582-8203',
      },
      {
        name: '구미',
        tel: '010-3537-8944',
      },
    ],
  },
  {
    region: '경남',
    cityDealerList: [
      {
        name: '함양, 거창, 산청',
        tel: '010-9983-0040',
      },
      {
        name: '창녕',
        tel: '010-2002-3371',
      },
      {
        name: '진주, 함안, 산청',
        tel: '010-9030-3636',
      },
      {
        name: '합천',
        tel: '010-4488-9701',
      },
    ],
  },
];
